/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Customer APP Sandbox API
 * OpenAPI spec version: v1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import { customAxiosInstance } from './mutator/customAxiosInstance';
import type { BodyType } from './mutator/customAxiosInstance';
/**
 * Unique Identifier
 */
export type Id = number;

export type OrganisationId = number;

export type AccessToken = string;

export type Code = string;

/**
 * User id
 */
export type CreatorId = number;

export type CreatorType = string;

/**
 * amount
 */
export type Amount = string;

/**
 * Creditor account uuid
 */
export type CreditorAccountUuid = string;

export type CreatorName = string;

/**
 * Country name
 */
export type CountryName = string;

/**
 * @nullable
 */
export type CurrencyCode = string | null;

/**
 * Currency ISO code
 */
export type CurrencyIso = string;

/**
 * @nullable
 */
export type CurrencyName = string | null;

/**
 * Country ISO
 */
export type CountryIso = string;

/**
 * Unique reference end to end id
 */
export type ExternalReference = string;

export type Email = string;

export type FullName = string;

export type IdExpiryDate = string;

export type IdIssuingCountryCode = string;

export type IdIssuingDate = string;

export type IdNumber = string;

export type IdType = string;

/**
 * Our unique reference
 */
export type UniqueReference = string;

/**
 * Reference
 */
export type Reference = string;

/**
 * Status
 */
export type Status = string;

export type OkStatus = string;

/**
 * Account holder type
 */
export type CreditorType = (typeof CreditorType)[keyof typeof CreditorType];

export const CreditorType = {
  organization: 'organization',
  private: 'private'
} as const;

/**
 * Transfer amount
 * @nullable
 */
export type TransferAmount = number | null;

/**
 * Transfer currency code
 * @nullable
 */
export type TransferCurrencyCode = string | null;

/**
 * Provider capability id
 * @nullable
 */
export type ProviderCapabilityId = string | null;

/**
 * Debtor account number
 */
export type DebtorAccountNumber = string;

/**
 * virtual account number
 */
export type VirtualAccountNumber = string;

/**
 * Datetime when the record was created
 */
export type CreatedAt = string;

/**
 * Datetime when the record was last updated
 */
export type UpdatedAt = string;

/**
 * <all> is only for frontend use
 */
export type WithdrawalStatus =
  (typeof WithdrawalStatus)[keyof typeof WithdrawalStatus];

export const WithdrawalStatus = {
  received: 'received',
  processing: 'processing',
  completed: 'completed',
  rejected: 'rejected',
  returned: 'returned'
} as const;

export type State = string;

export type StreetName = string;

export type StatusTransitions = StatusTransition[];

/**
 * For Details > History section
 */
export interface StatusTransition {
  id?: Id;
  created_at?: CreatedAt;
  status_category?: WithdrawalStatus;
}

export type StatusTransitionsWithReasonCode = StatusTransitionWithReasonCode[];

/**
 * For Details > History section
 */
export interface StatusTransitionWithReasonCode {
  id?: Id;
  created_at: CreatedAt;
  status: WithdrawalStatus;
  reason_code: WithdrawalReasonCode;
}

/**
 * admin, operations member or reviewer
 */
export type RoleName = string;

export interface ReasonCodeObject {
  id: Id;
  reason_code_id: Id;
  kind: string;
  group: string;
  symbol: string;
  external_message: string;
  reason: string;
}

export interface WithdrawalReasonCode {
  reason: string;
  external_message: string;
}

/**
 * @nullable
 */
export type DisbursementPartyIdentification = {
  /** @nullable */
  full_name: string | null;
  /** @nullable */
  birthdate: string | null;
  /** @nullable */
  address: string | null;
  /** @nullable */
  city: string | null;
  country_code: CountryIso;
  /** @nullable */
  postal_code?: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  mobile_number: string | null;
  /** @nullable */
  vop_result?: string | null;
  /** @nullable */
  vop_matched_name?: string | null;
} | null;

/**
 * @nullable
 */
export type PartyIdentification = {
  /** Creditor address */
  address_lines?: string;
  /** Creditor city */
  city?: string;
  country_code?: CountryIso;
  /** Creditor name */
  name?: string;
  /** Creditor postcode */
  postcode?: string;
  /** Account holder type */
  type?: string;
  /** Dob */
  birthdate?: string;
} | null;

/**
 * @nullable
 */
export type CreditorAccount = {
  /** @nullable */
  iban: string | null;
  /** @nullable */
  account_number: string | null;
  /** @nullable */
  account_number_type: string | null;
  /** @nullable */
  bank_bic: string | null;
  /** @nullable */
  bank_name: string | null;
  /** @nullable */
  bank_clearing_system_id: string | null;
  /** @nullable */
  bank_clearing_system_code: string | null;
  /** @nullable */
  bank_branch_id: number | null;
  /** @nullable */
  bank_branch_name: number | null;
  /** @nullable */
  country_code: string | null;
} | null;

/**
 * @nullable
 */
export type PartyIdentificationAccount = {
  id?: string;
  account_number?: string;
  bank_bic?: string;
  bank_branch_id?: number;
  bank_clearing_system_code?: number;
  country_code?: string;
  iban?: string;
  type?: string;
} | null;

/**
 * @nullable
 */
export type IntermediaryAgent = {
  /** @nullable */
  bank_bic: string | null;
  /** @nullable */
  bank_name: string | null;
} | null;

/**
 * @nullable
 */
export type IntermediaryAgentAccount = {
  /** @nullable */
  account_number: string | null;
  /** @nullable */
  iban: string | null;
} | null;

export interface Success {
  /** Successful operation response */
  success?: boolean;
}

export type AttachmentOwnerType =
  (typeof AttachmentOwnerType)[keyof typeof AttachmentOwnerType];

export const AttachmentOwnerType = {
  'Disbursement::PaymentRequest': 'Disbursement::PaymentRequest',
  'Disbursement::PaymentRequestDraft': 'Disbursement::PaymentRequestDraft',
  'Disbursement::PaymentRequestBatch': 'Disbursement::PaymentRequestBatch'
} as const;

export type AttachmentCreatorType =
  (typeof AttachmentCreatorType)[keyof typeof AttachmentCreatorType];

export const AttachmentCreatorType = {
  'Customer::User': 'Customer::User',
  'Admin::User': 'Admin::User'
} as const;

export interface Attachment {
  id: Id;
  uuid: Uuid;
  file_name: FileName;
  format: string;
  owner_id: Id;
  owner_type: AttachmentOwnerType;
  creator_id?: Id;
  creator_type?: AttachmentCreatorType;
  created_at: CreatedAt;
  updated_at: CreatedAt;
}

export type CancellationsInitiatorType =
  (typeof CancellationsInitiatorType)[keyof typeof CancellationsInitiatorType];

export const CancellationsInitiatorType = {
  'Customer::User': 'Customer::User',
  'Admin::User': 'Admin::User',
  'Customer::Organisation': 'Customer::Organisation'
} as const;

export interface Cancellations {
  id?: Id;
  initiator_id?: Id;
  /** @nullable */
  initiator_name?: CreatorName;
  initiator_type?: CancellationsInitiatorType;
  created_at?: string;
  status?: string;
}

export interface FeatureFlag {
  'CBP-1761-customer-app-batches'?: boolean;
  'CBP-2001-approval-workflow-manual-payouts'?: boolean;
  'CBP-2870-withdrawal-accounts-enabled'?: boolean;
  'CBP-8000-receiver-management'?: boolean;
  'CBP-10746-e2e-test-cases-field-enabled'?: boolean;
  'PEGO-12125-insight-section-customer-app'?: boolean;
  'PEGO-12738-sandbox-customer-app-api-docs'?: boolean;
  'PEGO-12664-create-receiver'?: boolean;
  'PEGO-13634-self-service-developer-settings'?: boolean;
  'PEGO-14432-mcp-tokens'?: boolean;
}

/**
 * Approval or rejection
 */
export interface Review {
  user_id: Id;
  created_at: CreatedAt;
  user_name: CreatorName;
  approved: boolean;
}

export interface PayoutReview {
  reviewer_id?: Id;
  created_at?: string;
  /** @nullable */
  reviewer_name?: CreatorName;
  approved?: boolean;
}

/**
 * uuidV4
 */
export type Uuid = string;

/**
 * contains file type
 */
export type FileName = string;

/**
 * report_uuid
 */
export type PayoutReportName = string;

/**
 * csv content
 */
export type PayoutReportData = string;

export interface PayoutReport {
  uuid: PayoutReportName;
  /** created after filter */
  created_after: string;
  /** created before filter */
  created_before: string;
  state_categories: string[];
  reason_codes: string[];
  organisation_id: OrganisationId;
  filename: PayoutReportName;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
  /**
   * amount from filter
   * @nullable
   */
  amount_from?: string | null;
  /**
   * amount to filter
   * @nullable
   */
  amount_to?: string | null;
  currency_code?: CurrencyCode;
  virtual_account_number?: VirtualAccountNumber;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
}

export interface PayoutReports {
  uuid?: PayoutReportName;
  amount?: Amount;
  /** created after filter */
  created_after?: string;
  /** created before filter */
  created_before?: string;
  state_categories?: string[];
  /**
   * amount from filter
   * @nullable
   */
  amount_from?: string | null;
  /**
   * amount to filter
   * @nullable
   */
  amount_to?: string | null;
  reason_codes?: string[];
  /**
   * business unit filter
   * @nullable
   */
  business_unit_name?: string | null;
  /**
   * local instrument filter
   * @nullable
   */
  local_instrument?: string | null;
  currency_code?: CurrencyCode;
  virtual_account_number?: VirtualAccountNumber;
  organisation_id?: OrganisationId;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
  filename?: PayoutReportName;
  created_at?: CreatedAt;
  updated_at?: UpdatedAt;
}

/**
 * report_uuid
 */
export type OrderReportUuid = string;

/**
 * report blob filename (always <uuid>.csv)
 */
export type OrderReportFilename = string;

/**
 * csv content
 */
export type OrderReportData = string;

/**
 * report processing lifecycle state
 */
export type OrderReportProcessingState =
  (typeof OrderReportProcessingState)[keyof typeof OrderReportProcessingState];

export const OrderReportProcessingState = {
  pending: 'pending',
  available: 'available',
  failed: 'failed'
} as const;

export interface OrderReport {
  uuid: OrderReportUuid;
  /** created after filter */
  created_after: string;
  /** created before filter */
  created_before: string;
  /**
   * order status filter
   * @nullable
   */
  status?: string | null;
  /**
   * reason code filter
   * @nullable
   */
  reason_code_id?: number | null;
  virtual_account_number?: VirtualAccountNumber;
  organisation_id: OrganisationId;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
  processing_state: OrderReportProcessingState;
  filename: OrderReportFilename;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
}

export interface OrderReports {
  uuid?: OrderReportUuid;
  /** created after filter */
  created_after?: string;
  /** created before filter */
  created_before?: string;
  /**
   * order status filter
   * @nullable
   */
  status?: string | null;
  /**
   * reason code filter
   * @nullable
   */
  reason_code_id?: number | null;
  virtual_account_number?: VirtualAccountNumber;
  organisation_id?: OrganisationId;
  creator_id?: CreatorId;
  creator_type?: CreatorType;
  processing_state?: OrderReportProcessingState;
  filename?: OrderReportFilename;
  created_at?: CreatedAt;
  updated_at?: UpdatedAt;
}

export type PayoutRequestStatus =
  (typeof PayoutRequestStatus)[keyof typeof PayoutRequestStatus];

export const PayoutRequestStatus = {
  received: 'received',
  rejected: 'rejected',
  returned: 'returned',
  action_required: 'action_required',
  completed: 'completed',
  pending: 'pending',
  processing: 'processing'
} as const;

export type PayoutRequestCurrentStateName =
  (typeof PayoutRequestCurrentStateName)[keyof typeof PayoutRequestCurrentStateName];

export const PayoutRequestCurrentStateName = {
  created: 'created',
  capability_selected: 'capability_selected',
  validating_external: 'validating_external',
  validated: 'validated',
  unable_to_validate_external: 'unable_to_validate_external',
  waiting_future_execution: 'waiting_future_execution',
  tstm_initiated: 'tstm_initiated',
  tstm_screened: 'tstm_screened',
  ready_for_v1: 'ready_for_v1',
  scheduled_for_processing: 'scheduled_for_processing',
  converting_to_v1: 'converting_to_v1',
  conversion_to_v1_failed: 'conversion_to_v1_failed',
  converted_to_v1: 'converted_to_v1',
  ready_for_transaction_screening: 'ready_for_transaction_screening',
  transaction_screening_in_process: 'transaction_screening_in_process',
  reviewing_transaction_screening: 'reviewing_transaction_screening',
  added_to_payout_planner: 'added_to_payout_planner',
  halted: 'halted',
  rerouted_to_different_provider: 'rerouted_to_different_provider',
  accepted_by_processing_provider: 'accepted_by_processing_provider',
  reconciliation_completed: 'reconciliation_completed',
  missing_capability: 'missing_capability',
  validation_schema_failed: 'validation_schema_failed',
  external_validation_failed: 'external_validation_failed',
  payment_request_cancelled: 'payment_request_cancelled',
  payment_returned: 'payment_returned',
  awaiting_kyc_documents: 'awaiting_kyc_documents',
  awaiting_extended_kyc: 'awaiting_extended_kyc',
  insufficient_funds: 'insufficient_funds'
} as const;

export type PayoutRequestPaymentRequestStateReasonCodesItemMeta = {
  [key: string]: unknown;
};

export type PayoutRequestPaymentRequestStateReasonCodesItem = {
  reason_code_id?: Id;
  meta?: PayoutRequestPaymentRequestStateReasonCodesItemMeta;
};

export type PayoutRequestStatusTransitionsItem = {
  name: string;
  timestamp: string;
};

export type PayoutRequestErrorsItem = {
  details: string[];
  pointer: string;
};

/**
 * @nullable
 */
export type PayoutRequestErrors = {
  [key: string]: PayoutRequestErrorsItem[];
} | null;

export interface PayoutRequest {
  id: Id;
  unique_reference: UniqueReference;
  /** end-to-end id */
  end_to_end_id: string;
  local_instrument: string;
  business_unit: string;
  amount: Amount;
  /** @nullable */
  batch_id: number | null;
  /**
   * manual, csv or api
   * @nullable
   */
  source: string | null;
  currency: CurrencyCode;
  status: PayoutRequestStatus;
  /**
   * creator id
   * @nullable
   */
  creator_id: number | null;
  /** @nullable */
  creator_name: string | null;
  current_state_name: PayoutRequestCurrentStateName;
  timestamp: string;
  /** @nullable */
  requested_execution_date: CreatedAt;
  /** @nullable */
  purpose_code: string | null;
  debtor: PayoutDebtor;
  ultimate_debtor: DisbursementPartyIdentification;
  creditor: DisbursementPartyIdentification;
  creditor_account: CreditorAccount;
  intermediary_agent: IntermediaryAgent;
  intermediary_agent_account: IntermediaryAgentAccount;
  /** @nullable */
  debtor_account: ReconciliationVirtualAccount;
  reason_codes: ReasonCodeObject[];
  payment_request_state_reason_codes: PayoutRequestPaymentRequestStateReasonCodesItem[];
  status_transitions: PayoutRequestStatusTransitionsItem[];
  cancellations: Cancellations[];
  /** @nullable */
  reviews: PayoutReview[] | null;
  /** @nullable */
  errors: PayoutRequestErrors;
}

export type PayoutRequestItemSource =
  (typeof PayoutRequestItemSource)[keyof typeof PayoutRequestItemSource];

export const PayoutRequestItemSource = {
  api: 'api',
  csv: 'csv',
  manual: 'manual',
  iso_20022: 'iso_20022'
} as const;

/**
 * state category name
 */
export type PayoutRequestItemState =
  (typeof PayoutRequestItemState)[keyof typeof PayoutRequestItemState];

export const PayoutRequestItemState = {
  received: 'received',
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  rejected: 'rejected',
  returned: 'returned',
  action_required: 'action_required'
} as const;

export interface PayoutRequestItem {
  id: Id;
  business_unit_id: Id;
  created_at?: CreatedAt;
  /** @nullable */
  batch_id?: number | null;
  /** @nullable */
  execution_date: string | null;
  source?: PayoutRequestItemSource;
  /** state category name */
  state: PayoutRequestItemState;
  local_instrument: string;
  end_to_end_id?: string;
  unique_reference?: UniqueReference;
  amount: Amount;
  debtor_account: VirtualAccountNumber;
  currency: CurrencyCode;
  attachments_count: number;
}

/**
 * waiting_approval or rejected
 */
export type PayoutDraftsItemStatus =
  (typeof PayoutDraftsItemStatus)[keyof typeof PayoutDraftsItemStatus];

export const PayoutDraftsItemStatus = {
  waiting_review: 'waiting_review',
  rejected: 'rejected'
} as const;

export interface PayoutDraftsItem {
  id: Id;
  created_at: CreatedAt;
  /** manual or batch */
  source: string;
  attachments_count: number;
  /** waiting_approval or rejected */
  status: PayoutDraftsItemStatus;
  creator_name?: string;
  local_instrument?: string;
  corridor?: string;
  /** number of current approvals */
  approvers_count?: number;
  /** end-to-end id */
  end_to_end_id?: string;
  amount?: Amount;
  debtor_account?: VirtualAccountNumber;
  currency?: CurrencyCode;
}

export type PayoutDraftDebtor = {
  name?: string;
  website?: string;
};

export type PayoutDraftDebtorAccount = {
  /** @nullable */
  id?: number | null;
  scheme_name?: string;
};

/**
 * waiting_review or rejected
 */
export type PayoutDraftStatus =
  (typeof PayoutDraftStatus)[keyof typeof PayoutDraftStatus];

export const PayoutDraftStatus = {
  waiting_review: 'waiting_review',
  rejected: 'rejected'
} as const;

export interface PayoutDraft {
  id: Id;
  amount?: Amount;
  /** number of current approvals */
  approvers_count: number;
  currency_code?: CurrencyCode;
  debtor?: PayoutDraftDebtor;
  ultimate_debtor?: PartyIdentification;
  /** @nullable */
  creditor?: PartyIdentification;
  creditor_account?: PartyIdentificationAccount;
  intermediary_agent?: IntermediaryAgent;
  intermediary_agent_account?: IntermediaryAgentAccount;
  debtor_account?: PayoutDraftDebtorAccount;
  /** user name */
  creator_name: string;
  /** manual or batch */
  source: string;
  /** creator id */
  user_id?: number;
  /** waiting_review or rejected */
  status: PayoutDraftStatus;
  /** end-to-end id */
  end_to_end_id?: string;
  local_instrument: string;
  corridor: string;
  approvals?: Review[];
  rejections?: Review[];
}

export type SchemaFieldsDefinitionDataCreditor = { [key: string]: FieldObject };

export type SchemaFieldsDefinitionDataCreditorAccount = {
  [key: string]: FieldObject;
};

export type SchemaFieldsDefinitionDataIntermediaryAgent = {
  [key: string]: FieldObject;
};

export type SchemaFieldsDefinitionDataIntermediaryAgentAccount = {
  [key: string]: FieldObject;
};

export type SchemaFieldsDefinitionData = {
  creditor: SchemaFieldsDefinitionDataCreditor;
  creditor_account: SchemaFieldsDefinitionDataCreditorAccount;
  intermediary_agent?: SchemaFieldsDefinitionDataIntermediaryAgent;
  intermediary_agent_account?: SchemaFieldsDefinitionDataIntermediaryAgentAccount;
};

export interface SchemaFieldsDefinition {
  data: SchemaFieldsDefinitionData;
}

export type CreatedPayoutDraftDataProductProductId = string | number;

export type CreatedPayoutDraftDataProductSchemaId = string | number;

export type CreatedPayoutDraftDataProduct = {
  local_instrument: string;
  product_id: CreatedPayoutDraftDataProductProductId;
  schema_id: CreatedPayoutDraftDataProductSchemaId;
};

export type CreatedPayoutDraftDataPayoutRequest = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataUltimateDebtor = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataCreditor = { [key: string]: FieldObject };

export type CreatedPayoutDraftDataCreditorAccount = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataDebtor = { [key: string]: FieldObject };

export type CreatedPayoutDraftDataIntermediaryAgent = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftDataIntermediaryAgentAccount = {
  [key: string]: FieldObject;
};

export type CreatedPayoutDraftData = {
  draft_id: number;
  product: CreatedPayoutDraftDataProduct;
  payout_request: CreatedPayoutDraftDataPayoutRequest;
  ultimate_debtor: CreatedPayoutDraftDataUltimateDebtor;
  creditor: CreatedPayoutDraftDataCreditor;
  creditor_account: CreatedPayoutDraftDataCreditorAccount;
  debtor: CreatedPayoutDraftDataDebtor;
  intermediary_agent?: CreatedPayoutDraftDataIntermediaryAgent;
  intermediary_agent_account?: CreatedPayoutDraftDataIntermediaryAgentAccount;
};

export interface CreatedPayoutDraft {
  data: CreatedPayoutDraftData;
}

export type FieldObjectUiField =
  (typeof FieldObjectUiField)[keyof typeof FieldObjectUiField];

export const FieldObjectUiField = {
  text: 'text',
  datepicker: 'datepicker'
} as const;

export type FieldObjectRules = { [key: string]: string };

export type FieldObjectValue = string | number;

export interface FieldObject {
  ui_field: FieldObjectUiField;
  rules?: FieldObjectRules;
  value: FieldObjectValue;
  errors: string[];
}

export type PayoutBatchStatus =
  (typeof PayoutBatchStatus)[keyof typeof PayoutBatchStatus];

export const PayoutBatchStatus = {
  waiting_review: 'waiting_review',
  completed: 'completed',
  rejected: 'rejected'
} as const;

export type PayoutBatchCurrency = {
  iso: CurrencyIso;
  name: CurrencyName;
};

export type PayoutBatchCountry = {
  iso: CountryIso;
  name: CountryName;
};

export interface PayoutBatch {
  id: number;
  name?: FileName;
  /** batch kind (iso or csv) */
  kind?: string;
  status?: PayoutBatchStatus;
  local_instrument?: string;
  total_payout_requests_count?: number;
  total_amount?: number;
  currency?: PayoutBatchCurrency;
  country?: PayoutBatchCountry;
  approvers_count?: number;
  accepted_payout_requests_count?: number;
  /** @nullable */
  creator_id?: CreatorId;
  /** @nullable */
  creator_name?: CreatorName;
  created_at?: CreatedAt;
  approvals?: Review[];
  rejections?: Review[];
}

export type CreatedBatchMetaCurrency = {
  iso: CurrencyIso;
  name: CurrencyName;
};

export type CreatedBatchMetaCountry = {
  iso: CountryIso;
  name: CountryName;
};

export interface CreatedBatchMeta {
  local_instrument: string;
  total_payout_requests: number;
  total_payout_requests_amount: number;
  currency: CreatedBatchMetaCurrency;
  country: CreatedBatchMetaCountry;
}

export interface CreatedBatchData {
  filename: string;
  /** file format */
  format: string;
  batch_id: number;
}

export type PayoutBatchesStatus =
  (typeof PayoutBatchesStatus)[keyof typeof PayoutBatchesStatus];

export const PayoutBatchesStatus = {
  waiting_review: 'waiting_review',
  completed: 'completed',
  rejected: 'rejected'
} as const;

export type PayoutBatchesCurrency = {
  iso: CurrencyIso;
  name: CurrencyName;
};

export type PayoutBatchesCountry = {
  iso: CountryIso;
  name: CountryName;
};

export interface PayoutBatches {
  id: number;
  name: string;
  /** batch kind (iso or csv) */
  kind: string;
  status: PayoutBatchesStatus;
  local_instrument: string;
  total_payout_requests_count?: number;
  total_amount?: number;
  currency: PayoutBatchesCurrency;
  country: PayoutBatchesCountry;
  approvers_count?: number;
  attachments_count: number;
  /** @nullable */
  creator_id?: CreatorId;
  /** @nullable */
  creator_name?: CreatorName;
  created_at?: CreatedAt;
}

export interface BatchDraft {
  amount: string;
  currency_code: string;
  local_instrument: string;
  /** end-to-end id */
  end_to_end_id: string;
  /** received, waiting_approval or rejected */
  state: string;
  batch_id: string;
  /** manual, csv or api */
  source?: string;
  creditor: PartyIdentification;
  creditor_account: PartyIdentificationAccount;
  debtor: PartyIdentification;
  debtor_account: PartyIdentificationAccount;
  ultimate_debtor: PartyIdentification;
}

export interface BatchDraftsItem {
  id: Id;
  /** amount */
  amount: number;
  created_at: CreatedAt;
  currency: CurrencyCode;
  debtor_account: string;
  attachments_count: number;
  /** received, waiting_approval or rejected */
  state: string;
  /** end-to-end id */
  end_to_end_id: string;
}

export interface PreferredPagination {
  /**
   * Next page
   * @nullable
   */
  cursor_next: string | null;
  /**
   * Previous page
   * @nullable
   */
  cursor_prev: string | null;
  /** Has next page */
  has_next_page: boolean;
  /** Has prev page */
  has_prev_page: boolean;
  /** Total number of items */
  total: number;
}

export interface Pagination {
  /**
   * Next page
   * @nullable
   */
  cursor_next?: number | null;
  /**
   * Previous page
   * @nullable
   */
  cursor_prev?: number | null;
  /** Has next page */
  has_next_page?: boolean;
  /** Has prev page */
  has_prev_page?: boolean;
  /** Total number of items */
  total?: number;
}

export interface OrdersIndexPagination {
  /**
   * Next page
   * @nullable
   */
  cursor_before?: string | null;
  /**
   * Next page
   * @nullable
   */
  cursor_after?: string | null;
  /** Total number of items */
  total?: number;
  /** Has orders */
  has_orders?: boolean;
}

export interface TotalCountPagination {
  /**
   * Next page
   * @nullable
   */
  cursor_next?: number | null;
  /**
   * Previous page
   * @nullable
   */
  cursor_prev?: number | null;
  /** Has next page */
  has_next_page?: boolean;
  /** Has prev page */
  has_prev_page?: boolean;
  /** Total number of items */
  total_count?: number;
}

/**
 * Status
 */
export type StatementItemKind =
  (typeof StatementItemKind)[keyof typeof StatementItemKind];

export const StatementItemKind = {
  transactions: 'transactions',
  charges: 'charges'
} as const;

export interface StatementItem {
  id?: Id;
  /** Status */
  kind?: StatementItemKind;
  file_name?: Reference;
  /** created after filter */
  from?: string;
  /** created before filter */
  to?: string;
  virtual_account_number?: VirtualAccountNumber;
  created_at?: CreatedAt;
  /** id of the csv file */
  csv_file_id?: number;
}

export interface NewStatement {
  id?: Id;
  /** created after filter */
  from?: string;
  /** created before filter */
  to?: string;
  account_id?: Id;
  reference?: Reference;
  period?: string;
  created_at?: CreatedAt;
  updated_at?: UpdatedAt;
  version?: number;
  /** transactions or charges */
  kind?: string;
  /** created, scheduled, in_progress, failed or completed */
  status?: string;
}

export interface PayoutDebtor {
  full_name: string;
  /** @nullable */
  website: string | null;
}

export interface Debtor {
  email?: Email;
  full_name?: FullName;
  date_of_birth?: string;
  country_of_residence?: CountryIso;
  created_at?: CreatedAt;
}

export interface Configuration {
  /** Irrelevant */
  throttling?: string;
  /** Number */
  batch_number_of_approvers?: string;
  /** Number */
  manual_payout_number_of_approvers?: string;
  /** v1 / v2 / dual */
  virtual_bank_bookkeeping?: string;
  /** Either on/off */
  withdrawals_enabled?: string;
  /** Irrelevant */
  fx_rate_end_point?: string;
  /** 1 if turned on */
  manual_payouts_enabled?: string;
  /** Either on/off */
  batches_enabled?: string;
  /** Either on/off */
  fx_widget_enabled?: string;
  /** c2c / bigedirect / layer 1 */
  crypto_widget_variant?: string;
  /** layer1 / c2c */
  crypto_provider?: string;
  /** Either on/off */
  customer_ab_testing?: string;
}

/**
 * account can be active, suspended, terminated or inactive
 */
export type AccountStatus = (typeof AccountStatus)[keyof typeof AccountStatus];

export const AccountStatus = {
  active: 'active',
  suspended: 'suspended',
  terminated: 'terminated',
  inactive: 'inactive'
} as const;

export interface Account {
  id?: Id;
  /** Account number */
  account_number?: string;
  /** Account Name (default is '<currency> account') */
  name?: string;
  /** latest balance on account */
  balance?: string;
  currency_code?: CurrencyCode;
  currency_name?: CurrencyName;
  /** Boolean telling if the account has any transactions */
  has_transactions?: boolean;
  /** Boolean telling if the account is owned by the requesting organisation */
  owner?: boolean;
  /** account can be active, suspended, terminated or inactive */
  status?: AccountStatus;
}

export interface AccountMeta {
  /** Count of movements (typical one request and one fee) */
  count?: number;
}

export interface AccountSummary {
  currency_code?: CurrencyCode;
  current_balance?: string;
  opening_balance?: string;
  closing_balance?: string;
}

export type AddressCountry = {
  id?: Id;
  /** Country ISO code */
  iso?: string;
  /** Country name */
  name?: string;
};

export interface Address {
  id?: Id;
  /** Line 1 of the organisation address */
  line1?: string;
  /** Line 2 of the organisation address */
  line2?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Postal code */
  postal_code?: string;
  country?: AddressCountry;
  /** Name of the organisation */
  organisation_name?: string;
}

export interface Movement {
  id?: Id;
  /** Order id */
  order_id?: string;
  reference?: Reference;
  amount?: Amount;
  payout_currency?: CurrencyCode;
  /** Amount */
  amount_payout_currency?: string;
  /** Type of movement */
  entry_type?: string;
  date?: CreatedAt;
  value_date?: CreatedAt;
  currency?: CurrencyCode;
  running_balance?: Amount;
}

export interface Movable {
  user_id?: Id;
  /** Additional info */
  internal_remarks?: string;
}

export interface AcceptedFundingConfiguration {
  banking_rail_id?: number;
  currency_iso?: CurrencyIso;
  email?: string;
  /** account number or custom */
  funding_reference?: string;
  /**
   * Operating company's account identifier from the network funding instruction.
   * @nullable
   */
  account_identifier?: string | null;
  /**
   * Network funding instruction ID
   * @nullable
   */
  network_funding_instruction_id?: number | null;
  organisation_id?: OrganisationId;
  owner_name?: string;
  /**
   * Provider account identifier from the network funding instruction.
   * @nullable
   */
  provider_account_identifier?: string | null;
  uuid?: Uuid;
  virtual_account_number?: VirtualAccountNumber;
}

export interface FundingConfiguration {
  /** states whether or not the instructions have been updated in admin */
  changed: boolean;
  uuid: Uuid;
  /** Typically account number, but can be custom */
  funding_reference: string;
  virtual_account_number: VirtualAccountNumber;
  currency_iso: CurrencyIso;
  beneficiary?: FundingConfigurationBeneficiary;
}

export interface FundingConfigurationBeneficiary {
  full_name?: string;
  bank_name?: string;
  bank_address?: string;
  iban?: string;
  account_number?: string;
  sort_code?: string;
  swift_code?: string;
  wallet_address?: string;
  crypto_network?: string;
}

export interface FundingConfigurations {
  virtual_account_number?: FundingConfiguration[];
}

export interface InternalAccountMovement {
  id?: Id;
  amount?: Amount;
  date?: CreatedAt;
  /** Type */
  reason?: string;
  reference?: Reference;
  movable_id?: Id;
  /** Type of movement */
  movable_type?: string;
  account_id?: Id;
  movable?: Movable;
}

export interface VirtualBankAccount {
  /** Unique identifier for the account */
  id?: number;
  /** The account number */
  account_number?: string;
  /** The current balance of the account */
  balance?: string;
  /** The three-letter ISO code for the account's currency */
  currency_code?: string;
  /** The name of the account's currency */
  currency_name?: string;
  /** Whether the account has any transactions */
  has_transactions?: boolean;
  /** The name of the account */
  name?: string;
  /** Whether the account is owned by the current user */
  owner?: boolean;
}

/**
 * The organisation
 */
export type SchemaExampleProductSchemaOrganisation = {
  /** The organisation id */
  id?: number;
  /** The organisation name */
  name?: string;
  /** @nullable */
  country_code?: string | null;
};

/**
 * The payout product
 */
export type SchemaExampleProductSchemaPayoutProduct = {
  /** The product id */
  id?: number;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  country?: string | null;
};

/**
 * The current schema
 */
export type SchemaExampleProductSchemaCurrentSchema = {
  /** The schema id */
  id?: number;
  /** The schema name */
  name?: string;
  /**
   * The schema description
   * @nullable
   */
  description?: string | null;
  updated_at?: string;
  label?: string;
};

export type SchemaExampleProductSchemaAvailableSchemasItem = {
  /** The schema id */
  id?: number;
  /** The schema name */
  name?: string;
  /**
   * The schema description
   * @nullable
   */
  description?: string | null;
  updated_at?: string;
  label?: string;
};

/**
 * The schema of the example
 */
export type SchemaExampleProductSchema = {
  /** The schema fields */
  schema_fields?: SchemaField[];
  /** The organisation */
  organisation?: SchemaExampleProductSchemaOrganisation;
  /** The payout product */
  payout_product?: SchemaExampleProductSchemaPayoutProduct;
  /** The current schema */
  current_schema?: SchemaExampleProductSchemaCurrentSchema;
  /** The available schemas */
  available_schemas?: SchemaExampleProductSchemaAvailableSchemasItem[];
};

export interface SchemaExampleProduct {
  /** The example string */
  example?: string;
  /** The schema of the example */
  schema?: SchemaExampleProductSchema;
}

export type SchemaFieldRulesItem = {
  /** A brief description of the rule */
  description?: string;
  /**
   * A hint for the rule
   * @nullable
   */
  hint?: string | null;
};

export interface SchemaField {
  /** The name of the field */
  field?: string;
  /** A brief description of the field */
  description?: string;
  /** The data type of the field */
  type?: string;
  rules?: SchemaFieldRulesItem[];
}

/**
 * The organisation
 */
export type V2SchemaExampleProductSchemaOrganisation = {
  /** The organisation id */
  id?: number;
  /** The organisation name */
  name?: string;
};

/**
 * The payout product
 */
export type V2SchemaExampleProductSchemaPayoutV2Product = {
  /** The product id */
  id?: number;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  country?: string | null;
};

/**
 * The schema of the example
 */
export type V2SchemaExampleProductSchema = {
  /** The schema fields */
  product_fields?: V2SchemaField[];
  /** The organisation */
  organisation?: V2SchemaExampleProductSchemaOrganisation;
  /** The payout product */
  payout_v2_product?: V2SchemaExampleProductSchemaPayoutV2Product;
};

export interface V2SchemaExampleProduct {
  /** The example string */
  example?: string;
  /** The schema of the example */
  schema?: V2SchemaExampleProductSchema;
}

export type V2SchemaFieldRulesItem = {
  /** A brief description of the rule */
  description?: string;
  /**
   * A hint for the rule
   * @nullable
   */
  hint?: string | null;
};

export interface V2SchemaField {
  /** The name of the field */
  field?: string;
  /** A brief description of the field */
  description?: string;
  /** The data type of the field */
  type?: string;
  rules?: V2SchemaFieldRulesItem[];
}

export interface ImpersonationExchangeResponse {
  access_token: AccessToken;
}

export interface InAppAlert {
  /** The unique identifier of the alert */
  id: number;
  /** The type of app the alert is for (e.g., 'customer_app', 'docs') */
  app_type: string;
  /** The type of alert (e.g., 'info', 'warning', 'error') */
  alert_type: string;
  /** The message content of the alert */
  alert_message: string;
  /** Whether the alert is currently enabled or not */
  enabled: boolean;
}

/**
 * Status
 */
export type WithdrawalAccountStatus =
  (typeof WithdrawalAccountStatus)[keyof typeof WithdrawalAccountStatus];

export const WithdrawalAccountStatus = {
  created: 'created',
  pending_approval: 'pending_approval',
  active: 'active',
  inactive: 'inactive',
  rejected: 'rejected'
} as const;

/**
 * @nullable
 */
export type WithdrawalAccountPartyIdentification = {
  /** Creditor address */
  address_lines?: string;
  /** Creditor city */
  city?: string;
  country_code?: CountryIso;
  /** Creditor name */
  name?: string;
  /** Creditor postcode */
  postcode?: string;
  /** Account holder type */
  type?: string;
} | null;

export interface WithdrawalAccount {
  id?: Id;
  uuid: Uuid;
  /** Label */
  label?: string;
  /** Organisation id */
  organisation_id: number;
  /**
   * Account number
   * @nullable
   */
  account_number?: string | null;
  /** Type */
  type?: string;
  /**
   * Bank bic
   * @nullable
   */
  bank_bic?: string | null;
  /**
   * Bank branch name
   * @nullable
   */
  bank_branch_name?: string | null;
  /**
   * Bank clearing system code
   * @nullable
   */
  bank_clearing_system_code?: string | null;
  /** Bank name */
  bank_name?: string;
  country_code: CountryIso;
  /** Currency */
  currency: string;
  /** Iban */
  iban?: string;
  /** Local instrument */
  local_instrument?: string;
  /**
   * Bank branch id
   * @nullable
   */
  bank_branch_id?: string | null;
  /**
   * Bank clearing system id
   * @nullable
   */
  bank_clearing_system_id?: string | null;
  /** Status */
  status: WithdrawalAccountStatus;
  /** @nullable */
  party_identification?: WithdrawalAccountPartyIdentification;
}

export interface WithdrawalAccountAuthorization {
  id?: Id;
  withdrawal_account_uuid?: Uuid;
  virtual_bank_account_number?: VirtualAccountNumber;
}

export interface WithdrawalRequest {
  id?: Id;
  amount?: Amount;
  creditor_account_uuid?: CreditorAccountUuid;
  currency_code?: CurrencyCode;
  external_reference?: ExternalReference;
  reference?: Reference;
  debtor_account_number?: DebtorAccountNumber;
  created_at?: CreatedAt;
}

export interface WithdrawalRequests {
  id?: Id;
  amount?: Amount;
  creditor_account_uuid?: CreditorAccountUuid;
  currency_code?: CurrencyCode;
  debtor_account_number?: DebtorAccountNumber;
  external_reference?: ExternalReference;
  reference?: Reference;
  status?: WithdrawalStatus;
  created_at?: CreatedAt;
}

export interface WithdrawalRequestWithAccount {
  id: Id;
  amount: Amount;
  creditor_account_uuid: CreditorAccountUuid;
  currency_code: CurrencyCode;
  external_reference?: ExternalReference;
  reference: Reference;
  status: WithdrawalStatus;
  transfer_amount?: TransferAmount;
  transfer_currency_code?: TransferCurrencyCode;
  provider_capability_id?: ProviderCapabilityId;
  debtor_account_number: DebtorAccountNumber;
  created_at?: CreatedAt;
  status_transitions: StatusTransitionsWithReasonCode;
  creditor_account?: WithdrawalAccount;
}

export interface Organisations {
  /** Organisation id */
  id?: number;
  /** Organisation name */
  name?: string;
  country_code?: CountryIso;
  /** Sales group */
  sales_group?: string;
}

export interface CustomerUserOrganisation {
  id: Id;
  /** organisation name */
  name: string;
  /** Public facing organisation name */
  ordering_institution: string;
  /** true means automatically chosen as active when initially logging on */
  default: boolean;
  role: RoleName;
}

export interface BusinessUnit {
  id: number;
  name: string;
  uuid: Uuid;
}

export interface Role {
  name: RoleName;
  /** optional description */
  description?: string;
}

export interface User {
  id: Id;
  email: string;
  first_name: string;
  last_name: string;
  role: RoleName;
  active: boolean;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
}

export interface UserItem {
  id: Id;
  email: string;
  first_name: string;
  last_name: string;
  /** inactive means removed from organisation */
  active: boolean;
  role: RoleName;
  created_at: CreatedAt;
  updated_at: UpdatedAt;
}

export interface CustomerAppContractedProducts {
  /** ID */
  id?: number;
  /** Product Id */
  product_id?: number;
  /** Currency of the product */
  product_currency_iso?: string;
}

export interface ContractedProducts {
  /** Product id */
  id?: number;
  currency_iso?: CurrencyIso;
  country_iso?: CountryIso;
  /** label */
  label?: string;
  /** label */
  instrument?: string;
}

export interface ReconciliationVirtualAccount {
  number?: string;
  currency?: string;
}

export interface DebtorAccount {
  /** The debtor account id */
  id?: string;
  /** The scheme used for the payout request */
  scheme_name?: string;
}

export interface PublishedPayoutRequest {
  debtor_account?: DebtorAccount;
  /** Sequential end-to-end id */
  end_to_end_id?: string;
  unique_reference?: UniqueReference;
  amount?: Amount;
  /** Currency of the payout */
  currency?: string;
  /** Currency of the draft */
  currency_code?: string;
  /** Datetime */
  timestamp?: string;
  /** State of the payout request */
  state?: string;
}

export interface Order {
  uuid?: Uuid;
  /** A unique identifier in your system for this Order */
  reference?: string;
  debtor?: Debtor;
  /** Status of your order */
  status?: string;
  amount?: Amount;
  /** The amount in minor units for the currency, computed as amount * 10 ** the currency decimal scale. For 2-decimal currencies this equals amount * 100 (cents). Until the storage widening lands, amounts with more than 2 decimals are rounded to 2 decimals on persist, so amount_cents follows that rounded value. */
  amount_cents?: number;
  currency_code?: CurrencyCode;
  created_at?: CreatedAt;
  virtual_account_number?: DebtorAccountNumber;
}

export interface CollectionOrderFindOne {
  uuid: Uuid;
  reference: Reference;
  debtor: Debtor;
  status: Status;
  business_unit: string;
  currency_code?: CurrencyCode;
  amount?: Amount;
  payments: CollectionOrderPaymentItem[];
  status_history: CollectionStatusHistoryItem[];
  refunds?: CollectionOrderRefundItem[];
  reason_codes: CollectionOrderReasonCodesItem[];
}

export interface CollectionOrderRefundItem {
  amount: string;
  category: string;
  currency_iso: string;
  status: CollectionRefundStatus;
  uuid: number;
  organisation_id: number;
  end_to_end_id: string;
  full_refund: boolean;
  created_at: string;
}

export interface CollectionStatusHistoryItem {
  status: string;
  created_at: string;
}

export interface CollectionOrderPaymentItem {
  uuid: Uuid;
  status: CollectionPaymentStatus;
  type: CollectionPaymentType;
  unique_reference: UniqueReference;
  created_at: CreatedAt;
}

export type CollectionRefundStatus =
  (typeof CollectionRefundStatus)[keyof typeof CollectionRefundStatus];

export const CollectionRefundStatus = {
  created: 'created',
  processing: 'processing',
  initiated: 'initiated',
  halted: 'halted',
  returned: 'returned',
  rejected: 'rejected',
  completed: 'completed',
  cancelled: 'cancelled',
  scheduled_for_retry: 'scheduled_for_retry',
  insufficient_funds: 'insufficient_funds'
} as const;

export type CollectionPaymentType =
  (typeof CollectionPaymentType)[keyof typeof CollectionPaymentType];

export const CollectionPaymentType = {
  bank_transfer: 'bank_transfer',
  instant_bank_transfer: 'instant_bank_transfer'
} as const;

export type CollectionOrderReasonCodesItemKind =
  (typeof CollectionOrderReasonCodesItemKind)[keyof typeof CollectionOrderReasonCodesItemKind];

export const CollectionOrderReasonCodesItemKind = {
  collection: 'collection'
} as const;

export type CollectionOrderReasonCodesItemGroup =
  (typeof CollectionOrderReasonCodesItemGroup)[keyof typeof CollectionOrderReasonCodesItemGroup];

export const CollectionOrderReasonCodesItemGroup = {
  action_required_for_refund: 'action_required_for_refund',
  action_required: 'action_required',
  refund_requested: 'refund_requested',
  order_cancelled: 'order_cancelled'
} as const;

export interface CollectionOrderReasonCodesItem {
  kind: CollectionOrderReasonCodesItemKind;
  group: CollectionOrderReasonCodesItemGroup;
  reason: string;
  external_message: string;
  symbol: string;
}

export interface CancelOrderReturnType {
  status: OkStatus;
}

export type CollectionPaymentStatus =
  (typeof CollectionPaymentStatus)[keyof typeof CollectionPaymentStatus];

export const CollectionPaymentStatus = {
  created: 'created',
  consent_required: 'consent_required',
  kyc_required: 'kyc_required',
  processing: 'processing',
  user_authorised: 'user_authorised',
  extra_info_required: 'extra_info_required',
  bank_info_collected: 'bank_info_collected',
  consent_given: 'consent_given',
  external_request_created: 'external_request_created',
  redirect_to_bank: 'redirect_to_bank',
  external_transfer_required: 'external_transfer_required',
  bank_processing: 'bank_processing',
  user_cancelled: 'user_cancelled',
  bank_rejected: 'bank_rejected',
  bank_authorised: 'bank_authorised',
  completed: 'completed',
  instructions_provided: 'instructions_provided',
  sum_too_low: 'sum_too_low',
  sum_too_high: 'sum_too_high',
  refunded: 'refunded',
  extra_bank_info_required: 'extra_bank_info_required',
  redirected_to_inpay: 'redirected_to_inpay',
  returned_from_provider: 'returned_from_provider'
} as const;

export interface CollectionPaymentDetails {
  debtor_country?: string;
  debtor_bank_name?: string;
}

export interface CollectionPaymentFindOne {
  uuid: Uuid;
  status: CollectionPaymentStatus;
  type: CollectionPaymentType;
  unique_reference: UniqueReference;
  created_at: CreatedAt;
  order: CollectionOrderFromPayment;
  details?: CollectionPaymentDetails;
  status_history?: CollectionStatusHistoryItem[];
}

export interface CollectionPaymentFindByUuidOrReference {
  uuid: Uuid;
  status: CollectionPaymentStatus;
  type: CollectionPaymentType;
  unique_reference: UniqueReference;
  created_at: CreatedAt;
  order: CollectionOrderFromPayment;
}

export interface CollectionOrderFromPayment {
  uuid: Uuid;
  /** A unique identifier in your system for this Order */
  reference: string;
  debtor: Debtor;
  /** Status of your order */
  status: string;
  amount: Amount;
  /** The amount in minor units for the currency, computed as amount * 10 ** the currency decimal scale. For 2-decimal currencies this equals amount * 100 (cents). Until the storage widening lands, amounts with more than 2 decimals are rounded to 2 decimals on persist, so amount_cents follows that rounded value. */
  amount_cents: number;
  currency: CurrencyCode;
  created_at: CreatedAt;
}

export interface CollectionCountStatusReportsDataItem {
  code: string;
  name: string;
  count: number;
  items?: CollectionCountStatusReportsDataItemReasonCode[];
}

export interface CollectionCountStatusReportsDataItemReasonCode {
  code: string;
  name: string;
  id: number;
}

export interface ExternalCode {
  id: number;
  value: string;
  external_code_set_id: number;
}

export interface ProductSchemas {
  id: number;
  label: string;
}

export interface PaymentInstruments {
  local_instrument_family: string;
  products: ProductItems[];
}

export interface ProductItems {
  id: number;
  corridor: string;
  /** @nullable */
  v2_product_id?: number | null;
}

export type PayoutStateCategoryStatItemCode =
  (typeof PayoutStateCategoryStatItemCode)[keyof typeof PayoutStateCategoryStatItemCode];

export const PayoutStateCategoryStatItemCode = {
  received: 'received',
  pending: 'pending',
  action_required: 'action_required',
  processing: 'processing',
  rejected: 'rejected',
  completed: 'completed',
  returned: 'returned'
} as const;

export type PayoutStateCategoryStatItemName =
  (typeof PayoutStateCategoryStatItemName)[keyof typeof PayoutStateCategoryStatItemName];

export const PayoutStateCategoryStatItemName = {
  Received: 'Received',
  Pending: 'Pending',
  Action_required: 'Action required',
  Processing: 'Processing',
  Rejected: 'Rejected',
  Completed: 'Completed',
  Returned: 'Returned'
} as const;

export interface PayoutStateCategoryStatItem {
  code: PayoutStateCategoryStatItemCode;
  name: PayoutStateCategoryStatItemName;
  count: number;
}

export interface PayoutStateCategoryStatMeta {
  count: number;
}

export interface PayoutReasonCodeStats {
  /** Reason-code stats for payment requests in the action_required category.
category: action_required
code: awaiting_kyc_documents
description: pending additional KYC information to be provided
 */
  action_required: PayoutReasonCodeStatItem;
  completed: PayoutReasonCodeStatItem;
  pending: PayoutReasonCodeStatItem;
  processing: PayoutReasonCodeStatItem;
  received: PayoutReasonCodeStatItem;
  rejected: PayoutReasonCodeStatItem;
  returned: PayoutReasonCodeStatItem;
}

export interface PayoutReasonCodeStatItem {
  items: PayoutReasonCodeItem[];
  meta: PayoutReasonCodeStatMeta;
}

export interface PayoutReasonCodeStatMeta {
  count: number;
  percentage: number;
}

export interface PayoutReasonCodeItem {
  id: number;
  code: string;
  name: string;
  count: number;
  percentage: number;
}

export type CreditorAddressLines = string;

export type CreditorBirthdate = string;

export type CreditorCity = string;

export type CreditorCountryCode = string;

export type CreditorCreatedBy = string;

export type CreditorEmail = string;

export type CreditorFullName = string;

export type CreditorMobileNumber = string;

export type CreditorPostcode = string;

export type CreditorProductId = number;

export type CreditorSchemaId = number;

export interface CreditorKeyValuePair {
  key: string;
  value: string;
}

export interface CreditorWithDetails {
  id: number;
  address_lines?: CreditorAddressLines;
  birthdate?: CreditorBirthdate;
  city?: CreditorCity;
  country_code?: CreditorCountryCode;
  country_of_birth_code?: CreditorCountryCode;
  country_of_residence_code?: CreditorCountryCode;
  created_by: CreditorCreatedBy;
  creditor_type?: CreditorType;
  email?: CreditorEmail;
  full_name?: CreditorFullName;
  id_expiry_date?: IdExpiryDate;
  id_issuing_country_code?: IdIssuingCountryCode;
  id_issuing_date?: IdIssuingDate;
  id_number?: IdNumber;
  id_type?: IdType;
  mobile_number?: CreditorMobileNumber;
  postcode?: CreditorPostcode;
  state?: State;
  street_name?: StreetName;
  product_id?: CreditorProductId;
  schema_id?: CreditorSchemaId;
  creditor_details: CreditorKeyValuePair[];
}

export type IntegrationValidationErrorErrorDetailsOneOf = {
  [key: string]: string | string[];
};

/**
 * Map of field name to validation message(s). A value is either a single string or an array of strings depending on the source validator (dry-validation and ActiveModel `to_hash` yield arrays; ActiveModel `to_h` yields a string). For a nested request body (e.g. bulk_update's `values`) the value is itself a map of sub-field to message(s), mirroring the request structure.
 */
export type IntegrationValidationErrorErrorDetails = {
  [key: string]:
    | string
    | string[]
    | IntegrationValidationErrorErrorDetailsOneOf;
};

export type IntegrationValidationErrorError = {
  /** error code from engine */
  code: number;
  title: string;
  /** Map of field name to validation message(s). A value is either a single string or an array of strings depending on the source validator (dry-validation and ActiveModel `to_hash` yield arrays; ActiveModel `to_h` yields a string). For a nested request body (e.g. bulk_update's `values`) the value is itself a map of sub-field to message(s), mirroring the request structure. */
  details: IntegrationValidationErrorErrorDetails;
};

export interface IntegrationValidationError {
  error: IntegrationValidationErrorError;
}

export interface ErrorResponse {
  error: ValidationErrorInvalidUuid;
}

/**
 * @nullable
 */
export type ErrorGenericDetailsNilDetails = unknown | null;

export interface ErrorGenericDetailsNil {
  title: string;
  /** @nullable */
  details: ErrorGenericDetailsNilDetails;
}

export interface ErrorGenericDetailString {
  title: string;
  details: string;
}

export type ErrorGenericDetailObjectDetails = {
  status?: string;
};

export interface ErrorGenericDetailObject {
  /** error code from engine */
  code: number;
  title: string;
  details: ErrorGenericDetailObjectDetails;
}

export interface ImpersonationGrantErrorResponse {
  error: string;
}

export type ErrorAttributesAttributes = {
  content?: string;
};

export interface ErrorAttributes {
  attributes: ErrorAttributesAttributes;
}

export interface NoOrganisationMembershipError {
  errors: NoOrganisationMembershipErrorsItem[];
}

export interface NoOrganisationMembershipErrorsItem {
  title: string;
  details: string[];
}

export interface RefundNoAmountError {
  title: string;
  details: string;
}

export interface RefundBadAmountError {
  title: string;
  details: string;
}

export interface RefundNotConfiguredError {
  title: string;
  details: string;
}

export interface ErrorGenericWithCodeDetailObject {
  /** error code from engine */
  code: number;
  title: string;
  details: string;
}

export type ValidationErrorInvalidUuidDetails = {
  uuid?: string[];
};

export interface ValidationErrorInvalidUuid {
  /** error code from engine */
  code: number;
  title: string;
  details: ValidationErrorInvalidUuidDetails;
}

export type UnauthorizedErrorItem = {
  title: string;
};

export type UnauthorizedError = UnauthorizedErrorItem[];

export type BadBatchStatusErrorDetails = {
  batch_id: string[];
};

export interface BadBatchStatusError {
  code: number;
  title: string;
  details: BadBatchStatusErrorDetails;
}

export type BatchBadFilterErrorDetailsFilter = {
  kind: string[];
};

export type BatchBadFilterErrorDetails = {
  filter: BatchBadFilterErrorDetailsFilter;
};

export interface BatchBadFilterError {
  code: number;
  title: string;
  details: BatchBadFilterErrorDetails;
}

export interface BatchNotFoundError {
  title: string;
  details: string;
}

export interface UsersNotAuthorized {
  title: string;
}

export interface UserValidationError {
  /** error code from engine */
  code: number;
  title: string;
  details: UserValidationAttributes;
}

export interface UserValidationAttributes {
  first_name: string[];
  last_name: string[];
  email: string[];
  active: string[];
  role: string[];
}

export type PayoutDraftValidationErrorErrorItemSource = {
  pointer?: string;
};

export type PayoutDraftValidationErrorErrorItem = {
  title?: string;
  details: string[];
  source?: PayoutDraftValidationErrorErrorItemSource;
};

export interface PayoutDraftValidationError {
  error: PayoutDraftValidationErrorErrorItem[];
}

export type InternalAccountMovementErrorsDetailsOneOf = {
  [key: string]: string[];
};

export type InternalAccountMovementErrorsDetails =
  | InternalAccountMovementErrorsDetailsOneOf
  | string;

export interface InternalAccountMovementErrors {
  /** error code from engine */
  code?: number;
  title?: string;
  details?: InternalAccountMovementErrorsDetails;
}

export interface PayoutBatchData {
  filename: string;
  format: string;
  batch_id: number;
  content: string;
}

export type PayoutBatchMetaCurrency = {
  iso: string;
  name: string;
};

export type PayoutBatchMetaCountry = {
  iso: string;
  name: string;
};

export interface PayoutBatchMeta {
  local_instrument: string;
  total_payout_requests: number;
  total_payout_requests_amount: number;
  currency: PayoutBatchMetaCurrency;
  country: PayoutBatchMetaCountry;
}

export type PayoutBatchErrorsItemSource = {
  pointer: string;
};

export type PayoutBatchErrorsItem = {
  title: string;
  details: string[];
  source: PayoutBatchErrorsItemSource;
};

/**
 * @nullable
 */
export type PayoutBatchErrors = PayoutBatchErrorsItem[] | null;

/**
 * @nullable
 */
export type PayoutError = {
  details: string[];
  pointer: string;
} | null;

export interface PayoutBatchErrorData {
  filename: string;
  format: string;
  /** CSV file content with errors */
  content: string;
}

export type PayoutBatchErrorMetaCountry = {
  /** @nullable */
  iso?: string | null;
  /** @nullable */
  name?: string | null;
};

export type PayoutBatchErrorMetaCurrency = {
  /** @nullable */
  iso?: string | null;
  /** @nullable */
  name?: string | null;
};

export interface PayoutBatchErrorMeta {
  country: PayoutBatchErrorMetaCountry;
  currency: PayoutBatchErrorMetaCurrency;
  local_instrument: string;
}

export type AuthSchemeType =
  (typeof AuthSchemeType)[keyof typeof AuthSchemeType];

export const AuthSchemeType = {
  pkcs: 'pkcs',
  jwt: 'jwt'
} as const;

/**
 * Customer-facing auth scheme as returned from read endpoints (index / enable / disable). The raw `secret` is never present here — only `secret_preview` (masked) for PKCS schemes. The scope is implicit (always external_app on this surface) and therefore omitted from the payload.
 */
export interface AuthScheme {
  uuid: Uuid;
  name: string;
  /**
   * PEM-encoded certificate (PKCS with encryption) or RSA public key (JWT).
   * @nullable
   */
  certificate?: string | null;
  scopes: string[];
  enabled: boolean;
  created_at: CreatedAt;
  type: AuthSchemeType;
  /** Masked view of the shared secret (8 bullets + last 4 characters). Omitted entirely for JWT schemes which have no shared secret. */
  secret_preview?: string;
  /** Only present on the disable (DELETE) response. The https webhooks that were deactivated as part of disabling this scheme (PEGO-14645-auth-scheme-disable-cascade flag ON). Empty when no webhook depended on this scheme. */
  deactivated_hooks?: AuthSchemeDependentHook[];
  /** Only present on the disable (DELETE) response. The https webhooks the cascade could NOT deactivate — they are still active and still reference the now-disabled scheme, so their next delivery will fail and deactivate them. A failed webhook never blocks the disable (leaving the credential live is the worse failure); it is reported here so it can be dealt with deliberately. Empty on a clean cascade. */
  failed_hooks?: AuthSchemeFailedHook[];
  /** Only present on the enable (POST .../enable) response. The https webhooks that are currently inactive and reference this scheme's auth_uuid — enabling never reactivates them; the caller must reactivate deliberately. */
  inactive_hooks?: AuthSchemeDependentHook[];
}

/**
 * Minimal summary of a webhook affected by an auth scheme disable/enable action.
 */
export interface AuthSchemeDependentHook {
  uuid?: Uuid;
  active?: boolean;
}

/**
 * Field-keyed validation messages from the webhook that refused to save.
 */
export type AuthSchemeFailedHookDetails = { [key: string]: unknown };

/**
 * A webhook the disable cascade could not deactivate, with the reason it could not be saved.
 */
export interface AuthSchemeFailedHook {
  uuid?: Uuid;
  /** Short title of the underlying error. */
  reason?: string;
  /** Field-keyed validation messages from the webhook that refused to save. */
  details?: AuthSchemeFailedHookDetails;
}

export type AuthSchemeWithSecretType =
  (typeof AuthSchemeWithSecretType)[keyof typeof AuthSchemeWithSecretType];

export const AuthSchemeWithSecretType = {
  pkcs: 'pkcs',
  jwt: 'jwt'
} as const;

/**
 * Auth scheme returned at creation time (`POST /auth_schemes` and `POST /auth_schemes/sign`) — includes the raw `secret` exactly once. The raw secret is not recoverable after this response; clients must persist it immediately. The scope is implicit (always external_app on this surface) and therefore omitted from the payload.
 */
export interface AuthSchemeWithSecret {
  uuid: Uuid;
  name: string;
  /** @nullable */
  certificate?: string | null;
  scopes: string[];
  enabled: boolean;
  created_at: CreatedAt;
  type: AuthSchemeWithSecretType;
  /** Raw shared secret. Returned ONCE at creation time and never recoverable afterwards. Absent for JWT schemes which use a customer-provided public key instead. */
  secret?: string;
}

export type McpTokenStatus =
  (typeof McpTokenStatus)[keyof typeof McpTokenStatus];

export const McpTokenStatus = {
  active: 'active',
  revoked: 'revoked',
  expired: 'expired'
} as const;

/**
 * Customer-facing MCP token as returned from read endpoints (index / revoke). The raw token value is never present here — only `token_preview` (masked).
 */
export interface McpToken {
  uuid: Uuid;
  /** Display label. Not unique — revoke-and-recreate under the same name is supported. */
  name: string;
  /** Masked view of the token (8 bullets + last 4 characters). */
  token_preview: string;
  status: McpTokenStatus;
  /** Expiry timestamp, set at creation (90 days). */
  expires_at: string;
  created_at: CreatedAt;
}

export type McpTokenWithTokenStatus =
  (typeof McpTokenWithTokenStatus)[keyof typeof McpTokenWithTokenStatus];

export const McpTokenWithTokenStatus = {
  active: 'active',
  revoked: 'revoked',
  expired: 'expired'
} as const;

/**
 * MCP token returned at creation time (`POST /mcp_tokens`) — includes the raw `token` exactly once.
 */
export interface McpTokenWithToken {
  uuid: Uuid;
  name: string;
  /** Raw MCP token (`tenant_mcp_` prefix + 40 alphanumerics). Returned ONCE at creation time and not recoverable after this response; clients must persist it immediately. A retried create issues a new token — revoke any orphaned token or let it expire. */
  token: string;
  /** Masked view of the token (8 bullets + last 4 characters). */
  token_preview: string;
  status: McpTokenWithTokenStatus;
  /** Expiry timestamp, set at creation (90 days). */
  expires_at: string;
  created_at: CreatedAt;
}

/**
 * Customer-facing business unit. `default` is true for the BU currently set as the organisation default; the SPA uses this to highlight the default in the list.
 */
export interface IntegrationBusinessUnit {
  uuid: Uuid;
  name: string;
  default: boolean;
}

export type WebhookCreatorType =
  (typeof WebhookCreatorType)[keyof typeof WebhookCreatorType];

export const WebhookCreatorType = {
  'Admin::User': 'Admin::User',
  'Customer::User': 'Customer::User',
  'Customer::Organisation': 'Customer::Organisation'
} as const;

/**
 * Customer-facing webhook — a 1:1 mirror of a Notification::Hook, addressed by `uuid`. Only hooks on the `https` channel are returned; other channels (email, sftp, swift_gateway) are admin-managed and out of scope for the customer app until a dedicated management surface ships. `editable` is kept as a defense-in-depth flag — true only when the row is also in customer scope on format (json or iso_20022) and engine (disbursement or collection); a row failing that check is still returned, but read-only. `creator_id` is omitted (null) for `creator_type: Admin::User` — those hooks are administrator-managed; only `Customer::*` creators expose an id.

 */
export interface Webhook {
  uuid: Uuid;
  creator_type: WebhookCreatorType;
  /**
   * Id of the creator; null for Admin::User (administrator-managed hook).
   * @nullable
   */
  creator_id?: number | null;
  editable: boolean;
  business_unit_uuid: Uuid;
  business_unit_name: string;
  engine: string;
  event: string;
  /** Always `https` on the customer surface; other channels are admin-managed. */
  channel: string;
  /** json or iso_20022 on the customer surface; other values appear only on read-only (editable: false) admin-managed rows.
   */
  format: string;
  /** @nullable */
  destination_url?: string | null;
  /** @nullable */
  auth_uuid?: string | null;
  active: boolean;
  created_at: CreatedAt;
}

/**
 * Optional call-level fallback, applied to entries that name no format of their own. Prefer the per-entry `format`. When neither is given the event's own default applies — see `GET /webhooks/events`.

 */
export type WebhookCreateRequestFormat =
  (typeof WebhookCreateRequestFormat)[keyof typeof WebhookCreateRequestFormat];

export const WebhookCreateRequestFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export type WebhookCreateRequestEventsItemOneOfFormat =
  (typeof WebhookCreateRequestEventsItemOneOfFormat)[keyof typeof WebhookCreateRequestEventsItemOneOfFormat];

export const WebhookCreateRequestEventsItemOneOfFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export type WebhookCreateRequestEventsItemOneOf = {
  event: string;
  format?: WebhookCreateRequestEventsItemOneOfFormat;
};

export type WebhookCreateRequestEventsItem =
  | string
  | WebhookCreateRequestEventsItemOneOf;

export interface WebhookCreateRequest {
  destination_url: string;
  /** Optional; defaults to the org's default business unit. */
  business_unit_uuid?: string;
  /** Required; an external_app-scoped auth scheme of the current organisation. */
  auth_uuid: string;
  /** Optional call-level fallback, applied to entries that name no format of their own. Prefer the per-entry `format`. When neither is given the event's own default applies — see `GET /webhooks/events`.
   */
  format?: WebhookCreateRequestFormat;
  /** Each entry is either an object `{event, format?}` or a bare event-name string, which is equivalent to `{event: "<name>"}`. Both shapes may be mixed in one array. `format` resolves per entry as: entry `format` → call-level `format` → the event's `default_format`. Since `format` is part of a subscription's identity, the same event may appear twice with two different formats to create two hooks. An entry naming an unknown event, or a format the event does not publish, does not fail the call — it comes back in `rejected`.
   */
  events: WebhookCreateRequestEventsItem[];
}

export type WebhookCreateResponseConflictsItemReason =
  (typeof WebhookCreateResponseConflictsItemReason)[keyof typeof WebhookCreateResponseConflictsItemReason];

export const WebhookCreateResponseConflictsItemReason = {
  already_active: 'already_active',
  inactive_exists: 'inactive_exists'
} as const;

export type WebhookCreateResponseConflictsItem = {
  event?: string;
  uuid?: Uuid;
  reason?: WebhookCreateResponseConflictsItemReason;
};

export type WebhookCreateResponseRejectedItemReason =
  (typeof WebhookCreateResponseRejectedItemReason)[keyof typeof WebhookCreateResponseRejectedItemReason];

export const WebhookCreateResponseRejectedItemReason = {
  unknown_event: 'unknown_event',
  format_not_supported_for_event: 'format_not_supported_for_event'
} as const;

export type WebhookCreateResponseRejectedItem = {
  event: string;
  /**
   * The format that was attempted; null when none was resolved.
   * @nullable
   */
  format: string | null;
  reason: WebhookCreateResponseRejectedItemReason;
};

export interface WebhookCreateResponse {
  data: Webhook[];
  /** One entry per event that already had a matching subscription (engine, event, url, auth_uuid, format). reason inactive_exists → FE offers reactivate via PATCH /webhooks/:uuid {active:true}; already_active → nothing to do.
   */
  conflicts: WebhookCreateResponseConflictsItem[];
  /** One entry per requested event that could not be subscribed. Sits beside `conflicts` rather than replacing it: a conflict is an existing subscription, a rejection is an unusable request entry. Neither is fatal — the remaining entries are still created, and the status is 201 whenever anything was created (200 when nothing was). `reason` is a stable, machine-readable value the FE can branch on for per-row copy: unknown_event → the event name is not in the registry, or belongs to an engine outside the customer surface (check for a typo); format_not_supported_for_event → the event does not publish in the requested format (see `GET /webhooks/events` for what it does publish).
   */
  rejected: WebhookCreateResponseRejectedItem[];
}

export type WebhookUpdateRequestFormat =
  (typeof WebhookUpdateRequestFormat)[keyof typeof WebhookUpdateRequestFormat];

export const WebhookUpdateRequestFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export interface WebhookUpdateRequest {
  destination_url?: string;
  auth_uuid?: string;
  active?: boolean;
  /** Move the hook to another BU within the same organisation. */
  business_unit_uuid?: string;
  format?: WebhookUpdateRequestFormat;
}

export type WebhookBulkUpdateRequestValuesFormat =
  (typeof WebhookBulkUpdateRequestValuesFormat)[keyof typeof WebhookBulkUpdateRequestValuesFormat];

export const WebhookBulkUpdateRequestValuesFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

export type WebhookBulkUpdateRequestValues = {
  destination_url?: string;
  auth_uuid?: string;
  active?: boolean;
  business_unit_uuid?: string;
  format?: WebhookBulkUpdateRequestValuesFormat;
};

export interface WebhookBulkUpdateRequest {
  uuids: Uuid[];
  values: WebhookBulkUpdateRequestValues;
}

export type WebhookBulkUpdateResponseDataItemStatus =
  (typeof WebhookBulkUpdateResponseDataItemStatus)[keyof typeof WebhookBulkUpdateResponseDataItemStatus];

export const WebhookBulkUpdateResponseDataItemStatus = {
  succeeded: 'succeeded',
  failed: 'failed'
} as const;

export type WebhookBulkUpdateResponseDataItemErrorDetailsOneOf = {
  [key: string]: string[];
};

export type WebhookBulkUpdateResponseDataItemErrorDetails =
  | string
  | WebhookBulkUpdateResponseDataItemErrorDetailsOneOf;

/**
 * Present only when status is failed. details is either a short reason string (e.g. not_found, not_editable) or a map of field to message(s), mirroring the per-uuid validation failure.

 * @nullable
 */
export type WebhookBulkUpdateResponseDataItemError = {
  details?: WebhookBulkUpdateResponseDataItemErrorDetails;
} | null;

export type WebhookBulkUpdateResponseDataItem = {
  uuid: Uuid;
  status: WebhookBulkUpdateResponseDataItemStatus;
  hook?: Webhook;
  /**
   * Present only when status is failed. details is either a short reason string (e.g. not_found, not_editable) or a map of field to message(s), mirroring the per-uuid validation failure.

   * @nullable
   */
  error?: WebhookBulkUpdateResponseDataItemError;
};

export interface WebhookBulkUpdateResponse {
  data: WebhookBulkUpdateResponseDataItem[];
}

export type WebhookEventEngine =
  (typeof WebhookEventEngine)[keyof typeof WebhookEventEngine];

export const WebhookEventEngine = {
  disbursement: 'disbursement',
  collection: 'collection'
} as const;

export type WebhookEventFormatsItem =
  (typeof WebhookEventFormatsItem)[keyof typeof WebhookEventFormatsItem];

export const WebhookEventFormatsItem = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

/**
 * The format POST /webhooks applies to this event when the request names none. Not always json — payment_request_batch_processed publishes only iso_20022.

 */
export type WebhookEventDefaultFormat =
  (typeof WebhookEventDefaultFormat)[keyof typeof WebhookEventDefaultFormat];

export const WebhookEventDefaultFormat = {
  json: 'json',
  iso_20022: 'iso_20022'
} as const;

/**
 * One subscribable event on the customer webhook surface. This is the authoritative list — the set of event names POST /webhooks accepts, and the formats each one publishes. Only events on the https channel belonging to an in-scope engine (disbursement, collection) appear; email-only events and other engines are omitted.

 */
export interface WebhookEvent {
  engine: WebhookEventEngine;
  event: string;
  /** Every format this event publishes, in registry order. Most events have exactly one, so a picker is only meaningful where this has more than one entry.
   */
  formats: WebhookEventFormatsItem[];
  /** The format POST /webhooks applies to this event when the request names none. Not always json — payment_request_batch_processed publishes only iso_20022.
   */
  default_format: WebhookEventDefaultFormat;
}

export interface WebhookEventsResponse {
  /** Sorted by (engine, event). */
  data: WebhookEvent[];
}

export interface WebhookResponse {
  data: Webhook;
}

export type PutSandboxFundingsTestCaseBody = {
  /** test case */
  test_case: string;
  /** funding uuid */
  funding_configuration_uuid: string;
  /** reference from funding instructions */
  funding_reference: string;
  /** amount */
  amount: string;
  /** beneficiary account (IBAN/number/wallet) */
  debtor_account_number: string;
};

export type PutSandboxFundingsTestCase200 = {
  data: Success;
};

export type PutSandboxFundingsTestCase422 = {
  error: ErrorGenericDetailsNil;
};

export type PutSandboxOrdersUuidTestCaseBodyTestCase =
  (typeof PutSandboxOrdersUuidTestCaseBodyTestCase)[keyof typeof PutSandboxOrdersUuidTestCaseBodyTestCase];

export const PutSandboxOrdersUuidTestCaseBodyTestCase = {
  complete_payment: 'complete_payment'
} as const;

export type PutSandboxOrdersUuidTestCaseBody = {
  test_case: PutSandboxOrdersUuidTestCaseBodyTestCase;
  /** Payment UUID */
  payment_uuid: string;
};

export type PutSandboxOrdersUuidTestCase200 = {
  data: Success;
};

/**
 * @nullable
 */
export type PutSandboxOrdersUuidTestCase422ErrorDetails = {
  order?: string[];
} | null;

export type PutSandboxOrdersUuidTestCase422Error = {
  title: string;
  /** @nullable */
  details: PutSandboxOrdersUuidTestCase422ErrorDetails;
};

export type PutSandboxOrdersUuidTestCase422 = {
  error: PutSandboxOrdersUuidTestCase422Error;
};

export type PutSandboxPayoutsUniqueReferenceTestCaseBodyTestCase =
  (typeof PutSandboxPayoutsUniqueReferenceTestCaseBodyTestCase)[keyof typeof PutSandboxPayoutsUniqueReferenceTestCaseBodyTestCase];

export const PutSandboxPayoutsUniqueReferenceTestCaseBodyTestCase = {
  success: 'success',
  returned: 'returned'
} as const;

export type PutSandboxPayoutsUniqueReferenceTestCaseBody = {
  test_case: PutSandboxPayoutsUniqueReferenceTestCaseBodyTestCase;
};

export type PutSandboxPayoutsUniqueReferenceTestCase200 = {
  data: Success;
};

export type PutSandboxPayoutsUniqueReferenceTestCase422 = {
  error: ErrorGenericDetailsNil;
};

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Trigger funding test case
 */
export const putSandboxFundingsTestCase = (
  organisationId: number,
  putSandboxFundingsTestCaseBody: BodyType<PutSandboxFundingsTestCaseBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PutSandboxFundingsTestCase200>(
    {
      url: `/sandbox/organisations/${organisationId}/fundings/test_case`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putSandboxFundingsTestCaseBody
    },
    options
  );
};

export const getPutSandboxFundingsTestCaseMutationOptions = <
  TError = PutSandboxFundingsTestCase422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSandboxFundingsTestCase>>,
    TError,
    { organisationId: number; data: BodyType<PutSandboxFundingsTestCaseBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSandboxFundingsTestCase>>,
  TError,
  { organisationId: number; data: BodyType<PutSandboxFundingsTestCaseBody> },
  TContext
> => {
  const mutationKey = ['putSandboxFundingsTestCase'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSandboxFundingsTestCase>>,
    { organisationId: number; data: BodyType<PutSandboxFundingsTestCaseBody> }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return putSandboxFundingsTestCase(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSandboxFundingsTestCaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSandboxFundingsTestCase>>
>;
export type PutSandboxFundingsTestCaseMutationBody =
  BodyType<PutSandboxFundingsTestCaseBody>;
export type PutSandboxFundingsTestCaseMutationError =
  PutSandboxFundingsTestCase422;

/**
 * @summary Trigger funding test case
 */
export const usePutSandboxFundingsTestCase = <
  TError = PutSandboxFundingsTestCase422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSandboxFundingsTestCase>>,
      TError,
      {
        organisationId: number;
        data: BodyType<PutSandboxFundingsTestCaseBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putSandboxFundingsTestCase>>,
  TError,
  { organisationId: number; data: BodyType<PutSandboxFundingsTestCaseBody> },
  TContext
> => {
  const mutationOptions = getPutSandboxFundingsTestCaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Trigger order test case
 */
export const putSandboxOrdersUuidTestCase = (
  organisationId: number,
  uuid: string,
  putSandboxOrdersUuidTestCaseBody: BodyType<PutSandboxOrdersUuidTestCaseBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PutSandboxOrdersUuidTestCase200>(
    {
      url: `/sandbox/organisations/${organisationId}/orders/${uuid}/test_case`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putSandboxOrdersUuidTestCaseBody
    },
    options
  );
};

export const getPutSandboxOrdersUuidTestCaseMutationOptions = <
  TError = PutSandboxOrdersUuidTestCase422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSandboxOrdersUuidTestCase>>,
    TError,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<PutSandboxOrdersUuidTestCaseBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSandboxOrdersUuidTestCase>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<PutSandboxOrdersUuidTestCaseBody>;
  },
  TContext
> => {
  const mutationKey = ['putSandboxOrdersUuidTestCase'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSandboxOrdersUuidTestCase>>,
    {
      organisationId: number;
      uuid: string;
      data: BodyType<PutSandboxOrdersUuidTestCaseBody>;
    }
  > = (props) => {
    const { organisationId, uuid, data } = props ?? {};

    return putSandboxOrdersUuidTestCase(
      organisationId,
      uuid,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSandboxOrdersUuidTestCaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSandboxOrdersUuidTestCase>>
>;
export type PutSandboxOrdersUuidTestCaseMutationBody =
  BodyType<PutSandboxOrdersUuidTestCaseBody>;
export type PutSandboxOrdersUuidTestCaseMutationError =
  PutSandboxOrdersUuidTestCase422;

/**
 * @summary Trigger order test case
 */
export const usePutSandboxOrdersUuidTestCase = <
  TError = PutSandboxOrdersUuidTestCase422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSandboxOrdersUuidTestCase>>,
      TError,
      {
        organisationId: number;
        uuid: string;
        data: BodyType<PutSandboxOrdersUuidTestCaseBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putSandboxOrdersUuidTestCase>>,
  TError,
  {
    organisationId: number;
    uuid: string;
    data: BodyType<PutSandboxOrdersUuidTestCaseBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPutSandboxOrdersUuidTestCaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Trigger payout test case
 */
export const putSandboxPayoutsUniqueReferenceTestCase = (
  organisationId: number,
  uniqueReference: string,
  putSandboxPayoutsUniqueReferenceTestCaseBody: BodyType<PutSandboxPayoutsUniqueReferenceTestCaseBody>,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PutSandboxPayoutsUniqueReferenceTestCase200>(
    {
      url: `/sandbox/organisations/${organisationId}/payouts/${uniqueReference}/test_case`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: putSandboxPayoutsUniqueReferenceTestCaseBody
    },
    options
  );
};

export const getPutSandboxPayoutsUniqueReferenceTestCaseMutationOptions = <
  TError = PutSandboxPayoutsUniqueReferenceTestCase422,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSandboxPayoutsUniqueReferenceTestCase>>,
    TError,
    {
      organisationId: number;
      uniqueReference: string;
      data: BodyType<PutSandboxPayoutsUniqueReferenceTestCaseBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSandboxPayoutsUniqueReferenceTestCase>>,
  TError,
  {
    organisationId: number;
    uniqueReference: string;
    data: BodyType<PutSandboxPayoutsUniqueReferenceTestCaseBody>;
  },
  TContext
> => {
  const mutationKey = ['putSandboxPayoutsUniqueReferenceTestCase'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSandboxPayoutsUniqueReferenceTestCase>>,
    {
      organisationId: number;
      uniqueReference: string;
      data: BodyType<PutSandboxPayoutsUniqueReferenceTestCaseBody>;
    }
  > = (props) => {
    const { organisationId, uniqueReference, data } = props ?? {};

    return putSandboxPayoutsUniqueReferenceTestCase(
      organisationId,
      uniqueReference,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSandboxPayoutsUniqueReferenceTestCaseMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putSandboxPayoutsUniqueReferenceTestCase>>
  >;
export type PutSandboxPayoutsUniqueReferenceTestCaseMutationBody =
  BodyType<PutSandboxPayoutsUniqueReferenceTestCaseBody>;
export type PutSandboxPayoutsUniqueReferenceTestCaseMutationError =
  PutSandboxPayoutsUniqueReferenceTestCase422;

/**
 * @summary Trigger payout test case
 */
export const usePutSandboxPayoutsUniqueReferenceTestCase = <
  TError = PutSandboxPayoutsUniqueReferenceTestCase422,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSandboxPayoutsUniqueReferenceTestCase>>,
      TError,
      {
        organisationId: number;
        uniqueReference: string;
        data: BodyType<PutSandboxPayoutsUniqueReferenceTestCaseBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putSandboxPayoutsUniqueReferenceTestCase>>,
  TError,
  {
    organisationId: number;
    uniqueReference: string;
    data: BodyType<PutSandboxPayoutsUniqueReferenceTestCaseBody>;
  },
  TContext
> => {
  const mutationOptions =
    getPutSandboxPayoutsUniqueReferenceTestCaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
